export const activities = {
  apply_filters_button: 'Aplicar filtros',
  date_from: 'El {from}',
  date_from_to: 'Del {from} hasta el {to}',
  date_to: 'Hasta el {to}',
  filter_activity_type_legend: 'Tipo de evento',
  filter_discipline_legend: 'Disciplina',
  filter_end_date_label: 'Hasta',
  filter_selection_legend: 'Actividad de selección',
  filter_selection_no_label: 'No',
  filter_selection_yes_label: 'Sí',
  filter_start_date_label: 'Desde',
  selection_activity_tooltip: 'Actividad de selección',
  show_filters_button: 'Mostrar filtros',
  view_more: 'Ver más',
  event_description: 'Descripción del evento',
  date_and_time: 'Fecha y hora',
  location: 'Localización',
  file_name: 'NOMBRE',
  file_date: 'FECHA',
  file_size: 'TAMAÑO',
}



// WEBPACK FOOTER //
// ./src/server/i18n/es/activities.js